module.exports = __webpack_public_path__ + "static/media/blog_13_3.189570b5.jpg";